module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_c-a4f510252804b3edd52df3cf21d5d651.png";